import React from 'react';
import { set, get } from 'lodash';
import { usePlanningBottomupState } from '../Context/index';
import { FPKeysPath } from '../TablesFieldPath';
import { checkIsNumber, roundOff } from '../../../Components/helper';
import useFPSalesHooks from '../Hooks/FPSalesHooks';
import useTerminalCalculationHooks from '../Hooks/useTerminalCalculationHooks';
import useMdCalculationHooks from '../Hooks/MdHooks';

export function RosStore() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { caluculateFPSSales } = useFPSalesHooks();
  const { calculateTerminal } = useTerminalCalculationHooks();
  const { calculateMd } = useMdCalculationHooks();
  const { planningBottomProducts, selectedLevel, selectedDisplayColumn } = planningBottomup;
  const level = selectedLevel?.level;
  const fpRos = [
    {
      keyName: 'fpRos',
      name: 'FP RoS',
    },
    {
      keyName: 'stores',
      name: 'Stores',
    },
  ];
  const getSizeRatio = (total, current) => {
    return roundOff(Number(current) / Number(total), 2);
  };

  const modifiedArray = async (copyState, index) => {
    const { basicInfo } = copyState[index];
    const { colour } = basicInfo;
    const filtered = copyState?.filter((data) => data.basicInfo?.colour?._id === colour?._id);
    let total = 0;
    filtered?.forEach((element) => {
      total += Number(element?.fpRos?.value);
    });
    copyState = copyState.map((eleData) => {
      if (eleData?.basicInfo?.colour?._id === colour?._id) {
        if (level === 7) {
          eleData.sizeRatio.value = getSizeRatio(total, eleData.fpRos.value);
        }
        if (level === 8) {
          eleData.lengthRatio.value = getSizeRatio(total, eleData.fpRos.value);
        }
      }
      return eleData;
    });

    return copyState;
  };

  const handleRosStoreInput = async (text, path, index) => {
    const copyState = planningBottomProducts;
    set(copyState, path, text);
    let currenObj = get(copyState, index);
    const { fpSalesUnits, fpSalesValue } = await caluculateFPSSales(currenObj);
    currenObj = { ...currenObj, fpSalesUnits, fpSalesValue };
    set(copyState, FPKeysPath(index).FP_SALES_UNIT, fpSalesUnits);
    set(copyState, FPKeysPath(index).FP_SALES_VALUES, fpSalesValue);
    currenObj = await calculateMd(currenObj);
    copyState[index] = await calculateTerminal(currenObj, level);
    if (level >= 7) {
      const data = await modifiedArray(copyState, index);
      setPlanningBottomup((prevState) => ({
        ...prevState,
        planningBottomProducts: data,
      }));
    } else {
      setPlanningBottomup((prevState) => ({
        ...prevState,
        planningBottomProducts: copyState,
      }));
    }
  };

  const disabled = (trItem, tdItem) => {
    if (selectedLevel?.level > 6 && trItem.totalFpRos > 0) {
      return true;
    }
    return !!(selectedLevel?.level > 6 && tdItem?.keyName === 'stores');
  };

  const isTableVisible = fpRos.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));

  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {fpRos?.map((fpRosItem, i) => {
              const isVisible = checkVisibleBottomUp(fpRosItem?.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-100px">
                    <span>{fpRosItem.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {fpRos?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {selectedLevel?.level >= 6 ? (
                          <input
                            type="text"
                            value={trItem[tdItem?.keyName]?.value}
                            onChange={(e) => {
                              if (checkIsNumber(e.target.value)) {
                                handleRosStoreInput(e.target.value, FPKeysPath(iParent, tdItem?.keyName).FPKEYS, iParent);
                              }
                            }}
                            className="form-control text-bordered"
                            disabled={disabled(trItem, tdItem) || !planningBottomup?.addEditBottomAccess}
                          />
                        ) : (
                          trItem[tdItem?.keyName]?.value || 0
                        )}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default RosStore;
